var React = require('react');

function SearchMd (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.71376 14.6275C12.4275 14.6275 14.6275 12.4275 14.6275 9.71376C14.6275 6.99999 12.4275 4.80005 9.71376 4.80005C6.99999 4.80005 4.80005 6.99999 4.80005 9.71376C4.80005 12.4275 6.99999 14.6275 9.71376 14.6275Z","strokeWidth":"1.67781","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M13.3359 13.3359L18.4077 18.4077","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

SearchMd.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = SearchMd;

SearchMd.default = SearchMd;
